import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "cursor"];
import React, { forwardRef } from 'react';
import Box from 'components/Box';
export var DashedBox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    _ref$cursor = _ref.cursor,
    cursor = _ref$cursor === void 0 ? 'pointer' : _ref$cursor,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, otherProps, {
    as: as || 'div',
    border: "dashed",
    borderRadius: "small",
    cursor: cursor
  }));
});
DashedBox.displayName = 'DashedBox';
export default DashedBox;